import { I18n } from '@calendly/i18n'
import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'
import { Link } from 'react-router-dom'

import { BackButton, NavigationContainer, PageContent, Subheader, SubheaderTitle } from 'components/page_elements'

const Providers = withSafeSuspense(lazy(async () => ({ default: (await import('./providers')).Providers })))

const SubHeaderWithBackButton = () => (
  <Subheader data-component="subheader">
    <NavigationContainer>
      <BackButton
        as={Link}
        to="/app/availability/connected_calendars"
      >
        {I18n.t('publisher.action.back')}
      </BackButton>
      <SubheaderTitle>{I18n.t('publisher.calendar.connected_calendars')}</SubheaderTitle>
    </NavigationContainer>
  </Subheader>
)

export const NewAccounts = () => (
  <>
    <SubHeaderWithBackButton />
    <PageContent newAdminIALayout>
      <Providers />
    </PageContent>
  </>
)
